import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

export const SeparatorRadio = (props) => {
  const { setSeparator } = props
  const [selectedRadio, setSelectedRadio] = useState("comma")
  const [inputSymbol, setInputSymbol] = useState("/")

  useEffect(() => {
    const symbol = evaluateSeparatorSymbol()
    setSeparator(symbol)
  }, [selectedRadio, inputSymbol])

  const handleInputChange = (value) => {
    setInputSymbol(value)
  }

  const evaluateSeparatorSymbol = () => {
    switch (selectedRadio) {
      case "comma": return ","
      case "tab": return "\t"
      case "other": return inputSymbol
      default: return ","
    }
  }

  return (
    <FormControl sx={{ width: "100%" }}>
      <FormLabel>Separator</FormLabel>
      <Grid container>
        <RadioGroup
          row
          value={selectedRadio}
          onChange={(e) => setSelectedRadio(e.target.value)}
        >
          <FormControlLabel value="comma" control={<Radio />} label="comma" />
          <FormControlLabel value="tab" control={<Radio />} label="tab" />
          <FormControlLabel value="other" control={<Radio />} label="other" />
        </RadioGroup>
        <TextField
          error={selectedRadio === "other" && !inputSymbol}
          size="small"
          sx={{ width: "3em" }}
          value={inputSymbol}
          onChange={(e) => handleInputChange(e.target.value)}
          disabled={selectedRadio !== "other"}
        />
      </Grid>
    </FormControl>
  )
}
